module.exports = __webpack_public_path__ + "static/media/dna-logo.51e4a65a.svg";